<template>
  <div :class="classes()">
    <div :class="`${el}__stage`">
      <Container autoHeight :class="`${el}__stageContainer`">
        <div :class="`${el}__stageInner`">
          <Headline
            :size="$matchMedia.l ? 'xxl' : 'l'"
            :heading="1"
            centered
            :staticClass="`${el}__stageHeadline`"
          >
            {{ $t('home.stage.headline1') }}
            <br />
            {{ $t('home.stage.headline2') }}
          </Headline>
          <Copy element="div" size="xl" :staticClass="`${el}__stageSubline`" centered>
            {{ $t('home.stage.subline') }}
          </Copy>
        </div>
      </Container>
      <div :class="`${el}__stageImages`">
        <div :class="`${el}__stageImageBg`">
          <Illustration brushColor="primaryCoral" name="title-2" :brush="1" :opacity="0.5" />
        </div>
        <div :class="`${el}__stageImageDevice`">
          <Picture
            :img="$t('careLevelCalculator.landingPage.device.v1.image')"
            :width="665"
            :height="390"
            responsive
          />
        </div>
      </div>
    </div>

    <div :class="`${el}__benefits`" id="teaser">
      <Container>
        <div :class="`${el}__inner`">
          <Headline
            :staticClass="`${el}__benefitsHeadline ${el}__benefitItemRelative`"
            size="l"
            :heading="2"
            responsive
            centered
          >
            {{ $t('home.benefits.headline') }}
          </Headline>
          <Features />
          <div :class="`${el}__benefitItemRelative`">
            <Benefits
              v-for="i in 4"
              :key="`benefitItem${i}`"
              :headline="$t(`home.benefits.item${i}.headline`)"
              :copy="$t(`home.benefits.item${i}.copy`)"
              :image="$t(`home.benefits.item${i}.image`)"
              :direction="i % 2 ? 'ltr' : 'rtl'"
            />
          </div>
          <Headline
            :staticClass="`${el}__benefitsHeadlineEnd`"
            size="l"
            :heading="2"
            responsive
            centered
          >
            {{ $t('home.benefits.headline.end') }}
          </Headline>
        </div>
      </Container>
    </div>
    <div :class="`${el}__mission`">
      <Container>
        <div :class="`${el}__missionInner`">
          <Headline
            :heading="4"
            size="l"
            centered
            responsive
            :staticClass="`${el}__missionHeadline`"
          >
            {{ $t('home.mission.headline') }}
          </Headline>
          <Headline
            :heading="4"
            size="s"
            centered
            responsive
            :staticClass="`${el}__missionSubline`"
          >
            {{ $t('home.mission.subline') }}
          </Headline>
          <Row :class="`${el}__missionRow`" verticalCenter>
            <Col :xs="12" :l="3" center :hasMargin="!$matchMedia.l">
              <Icon name="illu-home" :class="`${el}__missionIcon`" :width="90" />
            </Col>
            <Col :xs="12" :l="9">
              <Copy element="p" responsive>
                {{ $t('home.mission.copy1') }}
              </Copy>
              <Copy element="p" responsive>
                <strong>{{ $t('home.mission.copy2') }}</strong>
              </Copy>
            </Col>
          </Row>
        </div>
      </Container>
    </div>

    <div :class="`${el}__trust`">
      <Container padded>
        <Headline
          :heading="4"
          size="s"
          centered
          responsive
          :staticClass="`${el}__trustpilotHeadline`"
        >
          {{ $t('trustpilot.headline') }}
        </Headline>

        <div :class="`${el}__trustpilot`">
          <Trustpilot type="slider" />
        </div>
        <div :class="`${el}__tuev`">
          <TuevCertificate />
        </div>
      </Container>
    </div>
    <ErrorModal404 v-if="statusCode === '404'" @closeErrorModal="statusCode = ''" />
  </div>
</template>

<script>
import Container from '@/objects/Container';
import Copy from '@/objects/Copy';
import Headline from '@/objects/Headline';
import Picture from '@/objects/Picture';
import Icon from '@/objects/Icon';
import Illustration from '@/objects/Illustration';
import Trustpilot from '@/objects/Trustpilot';
import TuevCertificate from '@/objects/TuevCertificate';
import Row from '@/components/Grid/Row';
import Col from '@/components/Grid/Col';
import Features from './subcomponents/Features';
import Benefits from './subcomponents/Benefits';
import ErrorModal404 from '@/components/ErrorModal404/ErrorModal404';

import { mapFieldsAuth } from '@/store/mapFields';
import Tracking from '@/helpers/tracking/Tracking';

export default {
  name: 'Home',
  components: {
    ErrorModal404,
    Container,
    Copy,
    Headline,
    Picture,
    Icon,
    Illustration,
    Trustpilot,
    TuevCertificate,
    Row,
    Col,
    Features,
    Benefits,
  },
  data() {
    return {
      statusCode: '',
      modal: false,
      inView: false,
      el: 'v-home',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
        };
      },
    };
  },
  computed: {
    ...mapFieldsAuth(['isAuthenticated']),
  },
  mounted() {
    Tracking.trackDatalayer({
      category: 'DPA_login',
      pagetype: 'service',
      product: 'Login',
    });

    if (this.$route.meta.status) {
      this.statusCode = this.$route.meta.status;
    }

    window.addEventListener('scroll', this.onScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    closeModal() {
      this.modal = false;
    },
    openModal() {
      this.modal = true;
    },
    onScroll() {
      const { top, height } = this.$el
        .querySelector('.v-home__benefitItem:first-of-type')
        .getBoundingClientRect();
      this.inView = top - window.innerHeight / 2 - height / 2 < 0;
    },
  },
};
</script>
